<template>
  <b-card
      title="مدیریت دسته بندی های بیماری"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 mr-auto ml-1"
                  variant="primary"
                  :to="{ name: 'addsicknesscategory'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updatesicknesscategory', params: { id: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Image"
              />
              {{ data.value }}
            </span>
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updatesicknesscategory', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  :id="`invoice-row-${data.item.Id}-preview-icon`"
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

export default {
  name: 'SicknessCategory',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },

        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.sicknesscategory.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.removeRow(this.$api.sicknesscategory.remove, 'Id', id)
    },
  },
}
</script>